var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Close } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { v4 } from 'uuid';
import { PlusHeaderIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { PDICheckKeys } from '../services/entity';
import AddPDIQuestionMobileView from './addPDIQuestionMobileView';
var InspectionQuestionGroupMobileView = function (_ref) {
    var _crud$PDICheckKeys$Co;
    var data = _ref.data, onClose = _ref.onClose;
    var crud = useAppSelector(function (state) { return state.crud; });
    var dynamicValues = crud === null || crud === void 0 || (_crud$PDICheckKeys$Co = crud[PDICheckKeys === null || PDICheckKeys === void 0 ? void 0 : PDICheckKeys.ConfigurationPDICheck]) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.data) === null || _crud$PDICheckKeys$Co === void 0 || (_crud$PDICheckKeys$Co = _crud$PDICheckKeys$Co.DynamicValues) === null || _crud$PDICheckKeys$Co === void 0 ? void 0 : _crud$PDICheckKeys$Co[0];
    var complaintConfig = (dynamicValues === null || dynamicValues === void 0 ? void 0 : dynamicValues.ComplaintConfiguration) || [];
    var dispatch = useAppDispatch();
    var id = useParams();
    var getSelectValuesByName = function (name) {
        var item = complaintConfig.find(function (entry) {
            var _entry$ComplaintTypeI;
            return (entry === null || entry === void 0 || (_entry$ComplaintTypeI = entry.ComplaintTypeId) === null || _entry$ComplaintTypeI === void 0 ? void 0 : _entry$ComplaintTypeI.Value) === name;
        });
        return item || [];
    };
    var customerComplaint = getSelectValuesByName("1");
    var observation = getSelectValuesByName("2");
    var defectCategory = getSelectValuesByName("5");
    var actionTaken = getSelectValuesByName("3");
    console.log('customerComplaint---', customerComplaint);
    console.log('observation----', observation);
    console.log('defectCategory----', defectCategory);
    console.log('actionTaken----', actionTaken);
    console.log('PDICheckData--', data);
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '1px',
            columnSize: 12,
            mb: 15,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            // bgcolor:'red',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'QuestionGroupName',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong',
                    sx: {
                        fontSize: 'xl',
                        fontWeight: 'strong'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "secondary[600]",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose();
                    }
                }, {
                    type: FormItemTypes.List,
                    label: '',
                    name: 'Questions',
                    value: null,
                    variant: 'comfortable',
                    columnSize: 12,
                    rowHeight: 72,
                    sx: {
                        pt: 2
                    },
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    sx: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word'
                                    }
                                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.QuestionName));
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'InspectionCriteria',
                            label: 'Inspection criteria',
                            disabled: true,
                            columnSize: 12,
                            valueGetter: function (val, row) { return val !== null && val !== void 0 && val.InspectionCriteria ? val === null || val === void 0 ? void 0 : val.InspectionCriteria : '-'; }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'IssueDescription',
                            label: 'SOP',
                            disabled: true,
                            columnSize: 12,
                            labelTypographyProps: {
                                pt: 2
                            },
                            valueSetter: function (value, row) {
                                var _value$ComplaintName, _value$ComplaintId;
                                return _objectSpread(_objectSpread({}, row), {}, {
                                    ComplaintName: (_value$ComplaintName = value === null || value === void 0 ? void 0 : value.ComplaintName) !== null && _value$ComplaintName !== void 0 ? _value$ComplaintName : '',
                                    ComplaintId: (_value$ComplaintId = value === null || value === void 0 ? void 0 : value.ComplaintId) !== null && _value$ComplaintId !== void 0 ? _value$ComplaintId : ''
                                });
                            },
                            valueGetter: function (val, row) { return val !== null && val !== void 0 && val.IssueDescription ? val === null || val === void 0 ? void 0 : val.IssueDescription : '-'; }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: '',
                            value: null,
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Inspection result',
                                    value: null,
                                    columnSize: 0,
                                    required: true,
                                    fontWeight: 'strong',
                                    fontSize: 'lg',
                                    labelTypographyProps: {
                                        paddingTop: 2.5
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'outlined',
                                    children: 'Pass all',
                                    color: 'success',
                                    columnSize: 0,
                                    startIcon: /*#__PURE__*/ React.createElement(Close, null),
                                    sx: {
                                        marginTop: 1.5
                                    },
                                    setFormState: function (formValues, currentValue) {
                                        return {
                                            InspectionResult: 1
                                        };
                                    },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Button,
                                        variant: (state === null || state === void 0 ? void 0 : state.InspectionResult) === 1 ? 'contained' : 'outlined'
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'outlined',
                                    children: 'Fail all',
                                    color: 'error',
                                    columnSize: 0,
                                    startIcon: /*#__PURE__*/ React.createElement(Close, null),
                                    sx: {
                                        marginTop: 1.5
                                    },
                                    setFormState: function (formValues, currentValue) {
                                        return {
                                            InspectionResult: 2
                                        };
                                    },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Button,
                                        variant: (state === null || state === void 0 ? void 0 : state.InspectionResult) === 2 ? 'contained' : 'outlined'
                                    }); }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: 'Value',
                                    label: 'Actual value',
                                    // required: true,
                                    columnSize: 12,
                                    // disabled: id == undefined || null ? true : false,
                                    setFieldProps: function (formValues, currValue, field, formApi) {
                                        return {
                                            type: this.type,
                                            disabled: !!(formValues !== null && formValues !== void 0 && formValues.QuestionGroupId)
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: 'Remarks',
                                    label: 'Remarks',
                                    // required: true,
                                    columnSize: 12,
                                    disabled: id == undefined || null ? true : false,
                                    maxLength: 200,
                                    // setFieldProps(formValues, currValue, field) {
                                    //     console.log('Reamrks---00--', formValues);
                                    //     return {
                                    //         type: this.type,
                                    //         sx: {
                                    //             required: formValues?.InspectionResult ? true : false,
                                    //         }
                                    //     }
                                    // },
                                    setFieldProps: function (formValues, currValue, field) {
                                        return {
                                            type: FormItemTypes.TextInput,
                                            required: (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionResult) === 2 ? true : false
                                        };
                                    }
                                }, (customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.length) !== 0 ? {
                                    type: FormItemTypes.SearchSelect,
                                    name: 'CustomerVoiceId',
                                    label: 'Customer voice :',
                                    // required: true,
                                    options: customerComplaint === null || customerComplaint === void 0 ? void 0 : customerComplaint.SelectValues,
                                    displayExpr: 'ComplaintName',
                                    valueExpr: 'id',
                                    columnSize: 12,
                                    disabled: id ? true : false,
                                    setFieldProps: function (formValues, currValue, field) {
                                        var _a = customerComplaint || {}, IsMandatory = _a.IsMandatory, InspectionStatus = _a.InspectionStatus;
                                        var InspectionResult = (formValues || {}).InspectionResult;
                                        var isCustomerVoiceMandatory = IsMandatory === true && (InspectionStatus === 'Pass' && InspectionResult === 1 || InspectionStatus === 'Fail' && InspectionResult === 2 || InspectionStatus === 'Both');
                                        return {
                                            type: this.type,
                                            required: isCustomerVoiceMandatory
                                        };
                                    }
                                } : null, (observation === null || observation === void 0 ? void 0 : observation.length) !== 0 ? {
                                    type: FormItemTypes.SearchSelect,
                                    name: 'ObservationId',
                                    label: 'Observation',
                                    // required: true,
                                    columnSize: 12,
                                    options: observation === null || observation === void 0 ? void 0 : observation.SelectValues,
                                    displayExpr: 'ComplaintName',
                                    valueExpr: 'id',
                                    disabled: id ? true : false,
                                    setFieldProps: function (formValues, currValue, field) {
                                        var _a = observation || {}, IsMandatory = _a.IsMandatory, InspectionStatus = _a.InspectionStatus;
                                        var InspectionResult = (formValues || {}).InspectionResult;
                                        var isObservationMandatory = IsMandatory === true && (InspectionStatus === 'Pass' && InspectionResult === 1 || InspectionStatus === 'Fail' && InspectionResult === 2 || InspectionStatus === 'Both');
                                        return {
                                            type: this.type,
                                            required: isObservationMandatory
                                        };
                                    }
                                } : null, (defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.length) !== 0 ? {
                                    type: FormItemTypes.SearchSelect,
                                    name: 'DefectCategoryId',
                                    label: 'Defect category',
                                    columnSize: 12,
                                    options: defectCategory === null || defectCategory === void 0 ? void 0 : defectCategory.SelectValues,
                                    displayExpr: 'ComplaintName',
                                    valueExpr: 'id',
                                    disabled: id ? true : false,
                                    setFieldProps: function (formValues, currValue, field) {
                                        var _a = defectCategory || {}, IsMandatory = _a.IsMandatory, InspectionStatus = _a.InspectionStatus;
                                        var InspectionResult = (formValues || {}).InspectionResult;
                                        var isDefectCategoryMandatory = IsMandatory === true && (InspectionStatus === 'Pass' && InspectionResult === 1 || InspectionStatus === 'Fail' && InspectionResult === 2 || InspectionStatus === 'Both');
                                        return {
                                            type: this.type,
                                            required: isDefectCategoryMandatory
                                        };
                                    }
                                } : null, (actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.length) !== 0 ? {
                                    type: FormItemTypes.SearchSelect,
                                    name: 'ActionTakenId',
                                    label: 'Action taken',
                                    // required: true,
                                    columnSize: 12,
                                    options: actionTaken === null || actionTaken === void 0 ? void 0 : actionTaken.SelectValues,
                                    displayExpr: 'ComplaintName',
                                    valueExpr: 'id',
                                    // disabled: id ? true : false,
                                    setFieldProps: function (formValues, currValue, field) {
                                        var _a = actionTaken || {}, IsMandatory = _a.IsMandatory, InspectionStatus = _a.InspectionStatus;
                                        var InspectionResult = (formValues || {}).InspectionResult;
                                        var isActionTakenMandatory = IsMandatory === true && (InspectionStatus === 'Pass' && InspectionResult === 1 || InspectionStatus === 'Fail' && InspectionResult === 2 || InspectionStatus === 'Both');
                                        return {
                                            type: this.type,
                                            required: isActionTakenMandatory
                                        };
                                    }
                                } : null, {
                                    type: FormItemTypes.TextInput,
                                    name: 'SAObservation',
                                    label: 'SA suggetion',
                                    // required: true,
                                    minRows: 5,
                                    multiline: true,
                                    columnSize: 12,
                                    maxLength: 200
                                }]
                        }]
                }]
        }, data !== null && data !== void 0 && data.IsAllowToAddCustomQuestion ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 70,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Newbtn',
                    children: 'Add question',
                    columnSize: 0,
                    color: 'primary',
                    variant: 'contained',
                    sx: {
                        paddingX: '15px',
                        paddingY: '10px',
                        fontSize: 'base',
                        fontWeight: 'medium'
                    },
                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                    setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        var result, newPayload, updatedQuestions;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: AddPDIQuestionMobileView,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    width: {
                                                        xs: '100%',
                                                        sm: '90%',
                                                        md: '70%'
                                                    },
                                                    height: '392px',
                                                    borderRadius: '12px'
                                                }
                                            },
                                            anchor: 'bottom'
                                        }
                                    }))];
                                case 1:
                                    result = _a.sent();
                                    console.log('result--00--00--', result);
                                    newPayload = result === null || result === void 0 ? void 0 : result.payload;
                                    if (!newPayload)
                                        return [2 /*return*/, {}];
                                    updatedQuestions = __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.Questions) || []), true), [_objectSpread({
                                            id: v4()
                                        }, newPayload)], false);
                                    return [2 /*return*/, {
                                            Questions: updatedQuestions
                                        }];
                            }
                        });
                    }); }
                }]
        } : null,
        // {
        //     type: FormItemTypes.Box,
        //     name: '',
        //     display: 'flex',
        //     columnSize: 12,
        //     position: 'fixed',
        //     bottom: 0,
        //     right: 0,
        //     bgcolor: 'white',
        //     p: 2,
        //     width: '100%',
        //     justifyContent: 'space-between',
        //     sx: { borderTop: '1px solid ', borderColor: 'secondary.200', gap: '16px' },
        //     elements: [
        //         {
        //             type: FormItemTypes.Button,
        //             name: '',
        //             children: 'Cancel',
        //             variant: 'contained',
        //             columnSize: 6,
        //         },
        //         {
        //             type: FormItemTypes.Button,
        //             name: '',
        //             children: 'Save',
        //             variant: 'contained',
        //             columnSize: 6,
        //         },
        //     ]
        // }
        {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: '#DEE4EB',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'CancelButton',
                    children: 'Cancel',
                    columnSize: 6,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    },
                    sx: {
                        fontSize: 'lg',
                        fontWeight: 'medium'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'SaveButton',
                    children: 'Save',
                    columnSize: 6,
                    fullWidth: true,
                    color: 'primary',
                    variant: 'contained',
                    onClick: function () { return 'submit'; },
                    sx: {
                        fontSize: 'lg',
                        fontWeight: 'medium'
                    },
                    setFormState: function (formValues, currValue, field) {
                        console.log('Questions---', formValues);
                        return {
                        // Questions:Questions
                        };
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        height: '90vh',
        p: 1.5
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        success: true,
                        data: _objectSpread({}, data)
                    }];
            });
        }); },
        getKey: "QuestionsData",
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    })));
};
export default InspectionQuestionGroupMobileView;
